import LogoCommonwealth from 'assets/images/backoffice/capital/logo-commonwealth.png';
import NewBadge from 'assets/images/backoffice/capital/new-badge.png';
import React from 'react';
import { browserHistory } from 'react-router';
import Button from '../Button';
import CategoryBorder from './CategoryBorder';
import styles from './ProductCard.css';

function FastLoanProduct(props) {
  const { enable } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <CategoryBorder color="blue" />
        <img src={NewBadge} className={styles['new-badge']} />
        <p className={styles.title}>Fast Loan</p>
        <div className={`${styles['logo-wrapper']} ${styles['fast-loan']}`}>
          <img className={styles['fast-logo']} src={LogoCommonwealth} />
        </div>
        <p className={styles.desc}>
          Dapatkan pinjaman modal hingga Rp200 juta dengan tenor hingga 3 tahun.
          Proses cepat dan mudah, hanya dalam 2 hari kerja.
        </p>
        {enable && (
          <div className={styles['action-wrapper']}>
            <Button
              title="Ajukan Pinjaman"
              onClick={() => browserHistory.push('/capital/fast-loan')}
            />
          </div>
        )}
        {!enable && (
          <div className={styles['action-wrapper']}>
            <Button title="Akan Datang" disabled />
          </div>
        )}
        <a
          className={styles.link}
          href="https://www.mokapos.com/fastloan-id"
          target="_blank"
        >
          Pelajari lebih lanjut
        </a>
      </div>
    </div>
  );
}

export default FastLoanProduct;
